import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5761 14.9395C15.4971 16.8226 12.899 18.5166 10.04 19.6686C7.60702 20.6276 5.56901 19.4316 5.27001 17.0336C4.90601 13.4985 4.91401 10.1145 5.27001 6.95551C5.59601 4.4635 7.84102 3.4055 10.04 4.3315C12.855 5.48451 15.3801 7.04951 17.5761 9.06052C19.4521 10.7595 19.4961 13.1745 17.5761 14.9395Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPlayLine;
